import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const PARTNERS = [
  {
    name: "Talabat",
    url: "https://www.talabat.com/qatar/the-zumo-company",
    logo: "https://customer-assets.emergentagent.com/job_zumo-fresh-juice/artifacts/mly882ij_WhatsApp%20Image%202026-04-15%20at%206.41.05%20PM.jpeg",
  },
  {
    name: "Snoonu",
    url: "https://snoonu.com/restaurants/the-zumo-trading",
    logo: "https://customer-assets.emergentagent.com/job_zumo-fresh-juice/artifacts/6cz9am5z_WhatsApp%20Image%202026-04-15%20at%206.39.06%20PM.jpeg",
  },
];

export default function OrderModal({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="sm:max-w-md rounded-3xl border-none"
        style={{ background: "#FCF8F6" }}
        data-testid="order-modal"
      >
        <DialogHeader>
          <DialogTitle
            className="text-2xl md:text-3xl font-medium text-center"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              color: "#283618",
            }}
          >
            Order Now
          </DialogTitle>
          <p
            className="text-sm text-center mt-2"
            style={{
              fontFamily: "'Manrope', sans-serif",
              color: "#6F5E58",
            }}
          >
            Choose your preferred delivery partner
          </p>
        </DialogHeader>
        <div className="flex items-center justify-center gap-10 py-8">
          {PARTNERS.map((partner) => (
            <a
              key={partner.name}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`order-partner-${partner.name.toLowerCase()}`}
              className="flex flex-col items-center gap-3 group cursor-pointer"
            >
              <div className="transition-transform duration-300 group-hover:scale-110">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-24 w-auto object-contain mix-blend-multiply"
                />
              </div>
              <span
                className="text-xs uppercase tracking-[0.15em] font-semibold transition-colors duration-300 group-hover:text-[#283618]"
                style={{
                  fontFamily: "'Manrope', sans-serif",
                  color: "#6F5E58",
                }}
              >
                {partner.name}
              </span>
            </a>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
